<template>
  <!-- [ Header ] start -->
  <header class="pc-header">
    <div class="header-wrapper">
      <!-- [Mobile Media Block] start -->
      <div class="me-auto pc-mob-drp">
        <ul class="list-unstyled">
          <!-- ======= Menu collapse Icon ===== -->
          <li class="pc-h-item pc-sidebar-collapse">
            <a href="#" class="pc-head-link ms-0" id="sidebar-hide" @click.prevent="$emit('toggle-sidebar')">
              <i class="ti ti-menu-2"></i>
            </a>
          </li>
          <li class="pc-h-item pc-sidebar-popup">
            <a href="#" class="pc-head-link ms-0" id="mobile-collapse" @click.prevent="$emit('toggle-mobile-menu')">
              <i class="ti ti-menu-2"></i>
            </a>
          </li>
        </ul>
      </div>
      <!-- [Mobile Media Block end] -->
      
      <div class="ms-auto">
        <ul class="list-unstyled">
          <!-- Notifications -->
          <li class="pc-h-item">
            <NotificationDropdown />
          </li>
          
          <!-- User profile dropdown -->
          <li class="pc-h-item">
            <ProfileDropdown />
          </li>
        </ul>
      </div>
    </div>
  </header>
  <!-- [ Header ] end -->
</template>

<script>
import { onMounted, onUnmounted } from 'vue';
import NotificationDropdown from '@/components/NotificationDropdown.vue';
import ProfileDropdown from '@/components/ProfileDropdown.vue';

export default {
  name: 'AppHeader',
  components: {
    NotificationDropdown,
    ProfileDropdown
  },
  emits: ['toggle-sidebar', 'toggle-mobile-menu'],
  setup() {
    const handleScroll = () => {
      const scrollTop = window.scrollY ?? document.documentElement.scrollTop ?? 0;
      if (scrollTop > 10) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    };

    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
      // İlk yüklemede kontrol et
      handleScroll();
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });
  }
};
</script>

<style scoped>
.header-wrapper {
  display: flex;
  align-items: center;
  padding: 0 24px;
  min-height: 70px;
  width: 100%;
}

.pc-head-link {
  color: var(--bs-body-color);
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.pc-head-link:hover {
  background: rgba(var(--bs-primary-rgb), 0.1);
  color: var(--bs-primary);
}
</style> 